<template>
  <div class="distribution-insights-grid">
    <SourceFillRateLoader v-if="loading" class="source-fill-rate" />
    <SourceFillRateTable v-else class="source-fill-rate" />
    <ArticleCardLoader v-if="loading" class="article-card" />
    <ArticleCard
      v-else
      class="article-card"
      pre-headline="HOW TO"
      image-file-name="survey-reach"
      headline="Increase your survey's reach"
      description="Tips on how to survey candidates who don’t apply through your job post"
      link="https://support.greenhouse.io/hc/en-us/articles/210382923-Send-EEOC-questionnaire-to-a-candidate-who-didn-t-apply-through-a-job-post"
      @link-click="handleArticleLinkClick"
    />
    <ReqFillRateLoader v-if="loading" class="req-fill-rate" />
    <ReqFillRateTable v-else class="req-fill-rate" />
    <ArticleCardLoader v-if="loading" class="article-card" />
    <ArticleCard
      v-else
      class="article-card"
      pre-headline="HOW TO"
      image-file-name="survey-settings"
      headline="Configure your survey settings in your ATS"
      description="Instructions on how to ensure your survey is enabled on each intended job post"
      link="https://support.greenhouse.io/hc/en-us/articles/360031720371-Enable-EEOC-questionnaire-on-job-post"
      @link-click="handleArticleLinkClick"
    />
  </div>
</template>

<script setup>
import ReqFillRateTable from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/ReqFillRateTable.vue';
import SourceFillRateTable from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/SourceFillRateTable.vue';
import ArticleCard from '@/components/insights/ProcessInsights/DemographicSurveyReport/ArticleCard.vue';
import ArticleCardLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/ArticleCardLoader.vue';
import ReqFillRateLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/ReqFillRateLoader.vue';
import SourceFillRateLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/SourceFillRateLoader.vue';
import { useTracking } from '@/stores/tracking/tracking';

defineProps({
  loading: { type: Boolean, default: false },
  reqFillRateLoading: { type: Boolean, default: false },
});

const handleArticleLinkClick = (event) => {
  const { link, headline } = event;

  useTracking().track({
    name: 'Selected Article Link in Demographic-survey-report page',
    params: {
      article_link: link,
      article_headline: headline,
    },
  });
};
</script>

<style scoped lang="less">
.distribution-insights-grid {
  display: grid;
  grid-row-gap: 16px;
  grid-column-gap: 24px;
  grid-template-columns: minmax(0, 1fr) 214px;
  grid-template-rows: auto 604px;
}

.req-fill-rate {
  grid-column: span 1;
  grid-row: span 1;
}

.article-card {
  grid-column: span 1;
}

.source-fill-rate {
  grid-column: span 1;
  grid-row: span 1;
}
</style>
